import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useVincularPlanejamentosTalhoes() {
  return useMutation(URL.PLANO_OPERACIONAL.VINCULAR_TALHOES, async (body: any) => {
    const response = await http.put(URL.PLANO_OPERACIONAL.VINCULAR_TALHOES, body);
    return response;
  });
}

export default useVincularPlanejamentosTalhoes;
